export const trigger = ":";
